import {Icon, Path, SVG} from '@wordpress/components';

const icon = <SVG xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><Path d="M140 896q-24.75 0-42.375-17.625T80 836V316q0-24.75 17.625-42.375T140 256h680q24.75 0 42.375 17.625T880 316v520q0 24.75-17.625 42.375T820 896H140Zm0-60h187V316H140v520Zm247 0h186V316H387v520Zm246 0h187V316H633v520Zm-246 0V316v520Z"/></SVG>
export default <Icon icon={ icon } />;
